export default "__VITE_ASSET__Bls_OEuB__"